(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["promo-countdown-bar"] && !Shopify.designMode) return;
  try {
    
  class PromoCountdownBar {
    constructor(element) {
      this.element = element;
      this.startTime = Date.parse(element.dataset.startTime);
      this.endTime = Date.parse(element.dataset.endTime);
      this.upcomingText = element.dataset.upcomingText || 'Coming soon';
      this.liveText = element.dataset.liveText || 'Just launched';
      this.expiredText = element.dataset.expiredText || 'Offer ended';
      this.showCentiseconds = element.dataset.showCentiseconds === 'true';
      this.days = element.querySelector('[data-pcd-days]');
      this.hours = element.querySelector('[data-pcd-hours]');
      this.minutes = element.querySelector('[data-pcd-minutes]');
      this.seconds = element.querySelector('[data-pcd-seconds]');
      this.centiseconds = element.querySelector('[data-pcd-centiseconds]');
      this.headline = element.querySelector('.pcd-bar__headline');
      this.link = element.dataset.pcdLink;
      this.modal = element.parentElement.querySelector('[data-pcd-modal]');
      this.modalContinue = this.modal ? this.modal.querySelector('[data-pcd-modal-continue]') : null;
      this.modalClose = this.modal ? this.modal.querySelector('[data-pcd-modal-close]') : null;
      this.tick = this.tick.bind(this);
      this.handleClick = this.handleClick.bind(this);
      this.handleKeydown = this.handleKeydown.bind(this);
      this.showModal = this.showModal.bind(this);
      this.closeModal = this.closeModal.bind(this);
      this.handleModalLayerClick = this.handleModalLayerClick.bind(this);
      this.handleEscape = this.handleEscape.bind(this);
      this.goToLink = this.goToLink.bind(this);
      if (this.link) {
        this.element.addEventListener('click', this.handleClick);
        this.element.addEventListener('keydown', this.handleKeydown);
        if (this.modalContinue) {
          this.modalContinue.addEventListener('click', this.closeModal);
        }
        if (this.modalClose) {
          this.modalClose.addEventListener('click', this.closeModal);
        }
        if (this.modal) {
          this.modal.addEventListener('click', this.handleModalLayerClick);
        }
      }
      if (this.modal && window.sessionStorage.getItem('pcdDiscountModalPending') === 'true') {
        window.sessionStorage.removeItem('pcdDiscountModalPending');
        window.setTimeout(this.showModal, 350);
      }
      this.tick();
    }

    pad(value) {
      return String(Math.max(0, value)).padStart(2, '0');
    }

    handleClick(event) {
      if (event.target.closest('a')) {
        return;
      }
      this.goToLink();
    }

    handleKeydown(event) {
      if (event.key !== 'Enter' && event.key !== ' ') {
        return;
      }
      event.preventDefault();
      this.goToLink();
    }

    showModal() {
      if (!this.modal) {
        return;
      }
      this.modal.hidden = false;
      document.documentElement.style.overflow = 'hidden';
      document.addEventListener('keydown', this.handleEscape);
    }

    closeModal() {
      if (this.modal) {
        this.modal.hidden = true;
      }
      document.documentElement.style.overflow = '';
      document.removeEventListener('keydown', this.handleEscape);
    }

    handleModalLayerClick(event) {
      if (event.target === this.modal || event.target === this.modalClose) {
        this.closeModal();
      }
    }

    handleEscape(event) {
      if (event.key === 'Escape') {
        this.closeModal();
      }
    }

    goToLink() {
      window.sessionStorage.setItem('pcdDiscountModalPending', 'true');
      window.location.href = this.link;
    }

    tick() {
      const now = Date.now();
      const hasStartTime = Number.isFinite(this.startTime);
      const hasEndTime = Number.isFinite(this.endTime);
      let targetTime = this.endTime;
      let headlineText = this.liveText;

      if (hasStartTime && now < this.startTime) {
        headlineText = this.upcomingText;
      }

      const distance = targetTime - now;

      if (!hasEndTime || now >= this.endTime || distance <= 0) {
        this.days.textContent = '00';
        this.hours.textContent = '00';
        this.minutes.textContent = '00';
        this.seconds.textContent = '00';
        if (this.centiseconds) {
          this.centiseconds.textContent = '00';
        }
        if (this.headline) {
          this.headline.textContent = this.expiredText;
        }
        return;
      }

      if (this.headline) {
        this.headline.textContent = headlineText;
      }

      const totalSeconds = Math.floor(distance / 1000);
      this.days.textContent = this.pad(Math.floor(totalSeconds / 86400));
      this.hours.textContent = this.pad(Math.floor((totalSeconds % 86400) / 3600));
      this.minutes.textContent = this.pad(Math.floor((totalSeconds % 3600) / 60));
      this.seconds.textContent = this.pad(totalSeconds % 60);

      if (this.centiseconds) {
        this.centiseconds.textContent = this.pad(Math.floor((distance % 1000) / 10));
      }

      if (this.showCentiseconds) {
        window.requestAnimationFrame(this.tick);
      } else {
        window.setTimeout(this.tick, 250);
      }
    }
  }

  document.querySelectorAll('[data-pcd-bar]').forEach((element) => {
    if (!element.dataset.pcdInitialized) {
      element.dataset.pcdInitialized = 'true';
      new PromoCountdownBar(element);
    }
  });

  } catch(e) { console.error(e); }
})();
})();
